module.exports = __webpack_public_path__ + "media/images/official/special_migration_06-aca2db7b00cbbf0950d23fa758c4a5af.jpg";